"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var prosemirror_model_1 = require("prosemirror-model");
var prosemirror_state_1 = require("prosemirror-state");
var behavior_1 = require("../basic/keymap/behavior");
var prosemirror_transform_1 = require("prosemirror-transform");
var const_1 = require("../const");
var prose_util_1 = require("../libs/prose-util");
var clearFormat = function (view) {
    var tr = view.state.tr;
    var _a = view.state, selection = _a.selection, doc = _a.doc;
    selection.ranges.forEach(function (_a) {
        var $from = _a.$from, $to = _a.$to;
        var curMark = (tr.storedMarks || []).concat($from.marks());
        curMark.forEach(function (mark) { return tr.removeStoredMark(mark); });
        prose_util_1.removeMark(doc, tr, $from.pos, $to.pos);
    });
    view.dispatch(tr);
    view.focus();
    return true;
};
exports.clearFormat = clearFormat;
var getMarkState = function (mark) {
    if (Object.keys(mark.attrs).length) {
        return mark.attrs;
    }
    else {
        return true;
    }
};
var getFormat = function (view, range) {
    var _a = view.state, doc = _a.tr.doc, selection = _a.selection, storedMarks = _a.storedMarks;
    var from = selection.from, to = selection.to, $from = selection.$from;
    if (range && typeof range.index === 'number' && typeof range.length === 'number') {
        from = range.index;
        to = from + range.length;
        $from = doc.resolve(from);
    }
    var res = {};
    var parentNode = $from.depth === 1 ? $from.parent : $from.node(-1);
    if (!parentNode)
        parentNode = view.state.doc;
    if (![const_1.NODE_NAME.P, const_1.NODE_NAME.DOC].includes(parentNode.type.name)) {
        res[parentNode.type.name] = parentNode.attrs;
    }
    if (from !== to) {
        doc.nodesBetween(from, to, function (node, pos, parent) {
            node.marks.forEach(function (mark) {
                res[mark.type.name] = getMarkState(mark);
            });
            if (node.isTextblock) {
                // 嵌套的
                if (parent.type.name !== const_1.NODE_NAME.DOC) {
                    res[parent.type.name] = parent.attrs;
                }
                else if (node.type.name !== const_1.NODE_NAME.P) {
                    res[node.type.name] = node.attrs;
                }
            }
            return !node.isLeaf;
        });
    }
    else {
        var curMarks = storedMarks ? storedMarks : $from.marks();
        if (curMarks.length) {
            curMarks.forEach(function (mark) {
                res[mark.type.name] = getMarkState(mark);
            });
        }
    }
    return res;
};
exports.getFormat = getFormat;
// setFormat相关
var LIST_TYPE = [const_1.NODE_NAME.O_LIST, const_1.NODE_NAME.B_LIST];
// 面向mark的spec.excludes，移除不能并存的mark
// prosemirror默认行为是禁止，需要先移除再设置
var removeConflictMark = function (tr, markType) {
    var res = tr;
    tr.selection.ranges.forEach(function (_a) {
        var $from = _a.$from, $to = _a.$to;
        tr.doc.nodesBetween($from.pos, $to.pos, function (node, nodePos) {
            if (node.isText && node.marks.length) {
                node.marks.forEach(function (mark) {
                    var excludes = mark.type.spec.excludes || '';
                    if (excludes === '_' || excludes.includes(markType.name)) {
                        res = res.step(new prosemirror_transform_1.RemoveMarkStep(Math.max($from.pos, nodePos), Math.min($to.pos, nodePos + node.nodeSize), mark));
                    }
                });
            }
        });
    });
    return res;
};
var replaceMark = function (markType, attrs, nTr) {
    var tr = removeConflictMark(nTr, markType);
    nTr.selection.ranges.forEach(function (_a) {
        var $from = _a.$from, $to = _a.$to;
        if ($from.pos === $to.pos) {
            tr.removeStoredMark(markType).addStoredMark(markType.create(attrs));
        }
        else {
            tr.removeMark($from.pos, $to.pos, markType).addMark($from.pos, $to.pos, markType.create(attrs));
        }
    });
    return nTr;
};
function markApplies(doc, ranges, type) {
    var loop = function (i) {
        var ref = ranges[i];
        var $from = ref.$from;
        var $to = ref.$to;
        var can = $from.depth === 0 ? doc.type.allowsMarkType(type) : false;
        doc.nodesBetween($from.pos, $to.pos, function (node) {
            if (can) {
                return false;
            }
            can = node.inlineContent && node.type.allowsMarkType(type);
        });
        if (can) {
            return { v: true };
        }
    };
    for (var i = 0; i < ranges.length; i++) {
        var returned = loop(i);
        if (returned)
            return returned.v;
    }
    return false;
}
var toggleMark = function (markType, attrs, nTr, storedMarks) {
    var _a = nTr.selection, empty = _a.empty, $cursor = _a.$cursor, ranges = _a.ranges;
    if ((empty && !$cursor) || !markApplies(nTr.doc, ranges, markType)) {
        return nTr;
    }
    var tr = attrs ? removeConflictMark(nTr, markType) : nTr;
    if ($cursor) {
        if (attrs) {
            tr = tr.addStoredMark(markType.create());
        }
        else if (markType.isInSet(storedMarks || $cursor.marks())) {
            tr = tr.removeStoredMark(markType);
        }
    }
    else {
        var has = false;
        for (var i = 0; !has && i < ranges.length; i++) {
            var ref$1 = ranges[i];
            var $from = ref$1.$from;
            var $to = ref$1.$to;
            has = nTr.doc.rangeHasMark($from.pos, $to.pos, markType);
        }
        for (var i$1 = 0; i$1 < ranges.length; i$1++) {
            var ref$2 = ranges[i$1];
            var $from$1 = ref$2.$from;
            var $to$1 = ref$2.$to;
            if (attrs) {
                tr.addMark($from$1.pos, $to$1.pos, markType.create());
            }
            else if (has) {
                tr.removeMark($from$1.pos, $to$1.pos, markType);
            }
        }
    }
    return tr;
};
// 检测选中区间是否有隔离节点
var containsIsolatingNode = function (ranges) {
    var $from = ranges[0].$from;
    var $to = ranges[0].$to;
    var isContain = false;
    $from.doc.nodesBetween($from.pos, $to.pos, function (node, pos) {
        if (isContain)
            return true;
        if (node.type.spec.isolating) {
            // from与to不在同一个隔离节点里面,或者选中了隔离节点
            if ($from.pos <= pos || $to.pos >= pos + node.nodeSize) {
                isContain = true;
            }
        }
    });
    return isContain;
};
// 根据ranges返回一个包含各个选区内容的数组
var getSelectedInfos = function (_a) {
    var doc = _a.doc, selection = _a.selection;
    var selectedInfos = [];
    var ranges = selection.ranges.sort(function (a, b) { return a.$from.pos - b.$from.pos; });
    // 开始收集的位置，主要用于isolating节点
    var startPos = selection.$from.depth ? ranges[0].$from.before(1) : 0;
    var containIsolatingNode = ranges.length === 1 && containsIsolatingNode(ranges);
    ranges.forEach(function (_a) {
        var $to = _a.$to, $selectFrom = _a.$from;
        var $from = $selectFrom;
        var extendedFrom = $from.pos;
        var extendedTo = $to.pos;
        var from = $from.pos;
        var to = $to.pos;
        var selectedNodes = [];
        doc.nodesBetween(from, to, function (curNode, nodePos, parent) {
            if (nodePos < startPos)
                return false;
            // 不处理跨区选中isolating节点
            if (containIsolatingNode && curNode.type.spec.isolating) {
                startPos = nodePos + curNode.nodeSize;
                $from &&
                    selectedNodes.length &&
                    selectedInfos.push({
                        selectedNodes: selectedNodes,
                        selectedRange: {
                            $from: $from,
                            $to: doc.resolve(nodePos)
                        },
                        wrappingRange: {
                            from: extendedFrom,
                            to: nodePos
                        }
                    });
                selectedNodes = [];
                $from = null;
                extendedFrom = startPos;
                return false;
            }
            // 收集inline块和叶子节点
            if (curNode.inlineContent) {
                var $pos = doc.resolve(nodePos + 1);
                if (!$from)
                    $from = $pos;
                var blockRange = $pos.blockRange();
                if (!blockRange)
                    blockRange = { start: nodePos, end: nodePos };
                var realNode_1 = curNode;
                // 如果是光标在嵌套的p标签内，则选中的是整个嵌套节点（旧逻辑）
                if (from === to && $pos.depth === 2 && curNode.type.name === const_1.NODE_NAME.P) {
                    realNode_1 = $pos.node(-1);
                    blockRange = doc.resolve($pos.before(-1) + 1).blockRange();
                }
                if (!selectedNodes.some(function (_a) {
                    var node = _a.node;
                    return node === realNode_1;
                })) {
                    selectedNodes.push({
                        node: realNode_1,
                        nodeRange: blockRange
                    });
                }
                var fixFrom = extendedFrom;
                var fixTo = extendedTo;
                // 修正选中嵌套节点时，选中rang不正确的问题
                // 拓展选区不超过 isolating Node
                if ($pos.depth > 1 && !parent.type.spec.isolating) {
                    if (parent.firstChild === realNode_1) {
                        fixFrom = $pos.before(-1);
                    }
                    if (parent.lastChild === realNode_1) {
                        fixTo = $pos.after(-1);
                    }
                }
                extendedFrom = Math.min(extendedFrom, blockRange.start, fixFrom);
                extendedTo = Math.max(extendedTo, blockRange.end, fixTo);
                return false;
            }
            else if (curNode.isLeaf) {
                selectedNodes.push({
                    node: curNode,
                    nodeRange: { start: nodePos, end: nodePos }
                });
            }
            return true;
        });
        selectedNodes.length &&
            selectedInfos.push({
                selectedNodes: selectedNodes,
                selectedRange: {
                    $from: $from,
                    $to: $to
                },
                wrappingRange: {
                    from: extendedFrom,
                    to: extendedTo
                }
            });
    });
    return selectedInfos.sort(function (a, b) { return b.selectedRange.$from.pos - a.selectedRange.$from.pos; });
};
// 列表层级变更后，selectedNodes中pos不正确的情况
var fixNodeRange = function (tr, wrappingRange, nodes) {
    var doc = tr.doc;
    var from = wrappingRange.from, to = wrappingRange.to;
    var i = 0;
    doc.nodesBetween(from, to > doc.nodeSize - 2 ? doc.nodeSize - 2 : to, function (node, pos) {
        if (nodes[i] && node === nodes[i].node) {
            nodes[i++].nodeRange = doc.resolve(pos + 1).blockRange();
            return false;
        }
        if (i >= nodes.length)
            return false;
        return !node.isLeaf;
    });
    return nodes;
};
// 把嵌套的节点都提升到顶层
var liftNestedNode = function (selectedNodes, _tr, wrappingRange) {
    var shouldFixRange = false;
    var extendedFrom = wrappingRange.from, extendedTo = wrappingRange.to;
    var tr = _tr;
    var _a = tr.selection, from = _a.from, to = _a.to;
    var res = [];
    for (var i = selectedNodes.length - 1; i >= 0; i--) {
        var _b = selectedNodes[i], node = _b.node, nodeRange = _b.nodeRange;
        var topPos = _tr.doc.resolve(nodeRange.start).before(1);
        // 深度计算到 isolating Node 或 root 为止
        var originDepth = nodeRange.depth;
        for (var j = nodeRange.depth; j >= 0; j--) {
            var parent_1 = nodeRange.$from.node(j);
            originDepth = nodeRange.depth - j;
            if (parent_1.type.spec.isolating) {
                break;
            }
        }
        var depth = originDepth;
        var initPos = nodeRange.start + 1;
        var pos = initPos;
        while (depth > 0) {
            tr = behavior_1.doLiftList(tr, pos);
            pos = tr.mapping.map(initPos);
            depth--;
            shouldFixRange = true;
        }
        res.unshift({ node: node, nodeRange: nodeRange, originDepth: originDepth, topPos: topPos });
    }
    if (shouldFixRange)
        res = fixNodeRange(tr, wrappingRange, res);
    extendedFrom = tr.mapping.map(extendedFrom);
    extendedTo = tr.mapping.map(extendedTo);
    from = tr.mapping.map(from);
    to = tr.mapping.map(to);
    return {
        nodes: res,
        extendedFrom: extendedFrom,
        extendedTo: extendedTo,
        from: from,
        to: to,
        docSize: tr.doc.nodeSize
    };
};
var checkAndMergeListItems = function (listItems, nodeType) {
    var start = null;
    var end = null;
    for (var i = 0; i <= listItems.length + 1; i++) {
        if (listItems[i]) {
            if (start === null) {
                start = i;
                end = i;
            }
            else if (typeof end === 'number') {
                end++;
            }
        }
        else if (typeof start === 'number' && typeof end === 'number') {
            // 把之前所有的子节点合并
            var deleteCount = end - start + 1;
            listItems.splice.apply(listItems, __spreadArrays([start,
                deleteCount,
                nodeType.createAndFill({}, listItems.slice(start, end + 1))], new Array(deleteCount - 1)));
            i = start + 1;
            start = null;
            end = null;
        }
    }
    return listItems;
};
// 切换有序/无序列表时根据list_item的层级关系构建新的列表
var createNestedList = function (nodes, nodeType) {
    var sortLists = nodes.reduce(function (res, selectedNode, idx) {
        var depth = selectedNode.originDepth - 1;
        var result = { node: selectedNode.node, idx: idx };
        if (!Array.isArray(res[depth])) {
            res[depth] = [result];
        }
        else {
            res[depth].push(result);
        }
        return res;
    }, []);
    var listItems = [];
    while (sortLists.length) {
        var curItems = sortLists.pop();
        if (curItems) {
            curItems.forEach(function (_a) {
                var node = _a.node, idx = _a.idx;
                listItems[idx] = node;
            });
        }
        if (sortLists.length) {
            listItems = checkAndMergeListItems(listItems, nodeType);
        }
    }
    return listItems.filter(function (item) { return item; });
};
/**
 * @param nodeTy 要创建的节点类型
 * @param node 包含的节点
 * @param attrs 传入的attrs
 */
var createNode = function (nodeTy, node, attrs) {
    if (attrs === void 0) { attrs = {}; }
    return nodeTy.createAndFill(Object.assign({}, node.attrs, attrs), node.content, node.marks);
};
// 根据内容恢复选区情况
var getRangeAfterReplace = function (state, tr, _a) {
    var extendedFrom = _a.extendedFrom, extendedTo = _a.extendedTo, $originFrom = _a.$originFrom, $originTo = _a.$originTo;
    var docSize = tr.doc.nodeSize - 2;
    var newFrom = extendedFrom;
    var newTo = extendedTo;
    if (!(state.selection instanceof prosemirror_state_1.AllSelection)) {
        var isMatchFrom_1 = false;
        var defaultPos_1 = null;
        var fromContent_1 = $originFrom.node().textContent;
        var toContent_1 = $originTo.node().textContent;
        tr.doc.nodesBetween(extendedFrom, Math.min(extendedTo, docSize), function (node, pos) {
            if (node.inlineContent) {
                if (defaultPos_1 === null)
                    defaultPos_1 = pos + 1;
                if (!isMatchFrom_1 && node.textContent === fromContent_1) {
                    newFrom = pos + 1 + $originFrom.parentOffset;
                    isMatchFrom_1 = true;
                }
                if (isMatchFrom_1 && node.textContent === toContent_1) {
                    newTo = pos + 1 + Math.min(node.textContent.length, $originTo.parentOffset);
                }
            }
            return isMatchFrom_1 ? false : !node.isLeaf;
        });
        if (!isMatchFrom_1) {
            newFrom = defaultPos_1 || newFrom;
            newTo = newFrom;
        }
    }
    return {
        from: newFrom,
        to: Math.min(newTo, docSize)
    };
};
// 将样式应用到节点,返回新的选区范围
var formatNodeType = function (nodeType, attributes, sNodes, selectedRange, wrappingRange, nTr, state) {
    var transaction = nTr;
    // 是否是嵌套的节点，嵌套节点的文本要放在defaultType里
    var isNestedNodeType = !nodeType.isTextblock;
    var contentNodeType = isNestedNodeType ? nodeType.contentMatch.defaultType : nodeType;
    var _a = liftNestedNode(sNodes, transaction, wrappingRange), selectedNodes = _a.nodes, extendedFrom = _a.extendedFrom, extendedTo = _a.extendedTo, docSize = _a.docSize;
    var newNodes = [];
    for (var i = 0; i < selectedNodes.length; i++) {
        var node = selectedNodes[i].node;
        if (node.type.name === const_1.NODE_NAME.LIST && LIST_TYPE.includes(nodeType.name)) {
            //  切换列表，要保留层级
            var listNodes = [];
            while (selectedNodes[i] &&
                selectedNodes[i].node.type.name === const_1.NODE_NAME.LIST &&
                (!listNodes.length || selectedNodes[i].topPos === listNodes[listNodes.length - 1].topPos)) {
                listNodes.push(selectedNodes[i]);
                i++;
            }
            i--;
            newNodes.push.apply(newNodes, createNestedList(listNodes, nodeType));
        }
        else if (prose_util_1.checkIsNestedTextBlock(node.type)) {
            // 单层嵌套文本块
            node.content.forEach(function (subNode) {
                var addNode = createNode(contentNodeType, subNode, attributes);
                addNode && newNodes.push(addNode);
            });
        }
        else {
            // 普通类型的节点
            var addNode = node;
            if (!addNode.isLeaf) {
                addNode = createNode(contentNodeType, node, contentNodeType === nodeType && attributes);
            }
            addNode && newNodes.push(addNode);
        }
    }
    var rootNodeType = isNestedNodeType ? nodeType : state.schema.nodes.doc; // dummy root
    var root = rootNodeType.createAndFill(attributes, newNodes);
    if (isNestedNodeType) {
        transaction.replaceRangeWith(extendedFrom, extendedTo, root);
    }
    else {
        transaction = transaction.replaceRange(extendedFrom, extendedTo, new prosemirror_model_1.Slice(root.content, 0, 0));
    }
    return getRangeAfterReplace(state, transaction, {
        extendedFrom: extendedFrom,
        extendedTo: extendedTo + transaction.doc.nodeSize - docSize,
        $originFrom: selectedRange.$from,
        $originTo: selectedRange.$to
    });
};
var formatSelection = function (formatType, formatValue, formatRange) { return function (state, tr) {
    var schema = state.schema, doc = state.doc, _a = state.selection, ranges = _a.ranges, anchor = _a.anchor, head = _a.head;
    // 根据设置的位置来重新设置选区
    var from = Math.min(anchor, head);
    var to = Math.max(anchor, head);
    var reSelect = function (_tr) { return _tr; };
    // 指定了formatRange的情况要保持设置前后选中内容一致
    if (formatRange) {
        reSelect = function (_tr) {
            if (state.selection instanceof prosemirror_state_1.AllSelection) {
                _tr.setSelection(new prosemirror_state_1.AllSelection(_tr.doc));
                // 在当前位置之前
            }
            else if (formatRange.to <= from) {
                var diffSize = _tr.doc.nodeSize - state.doc.nodeSize;
                return _tr.setSelection(prosemirror_state_1.TextSelection.create(_tr.doc, from + diffSize, to + diffSize));
            }
            else {
                _tr.setSelection(prosemirror_state_1.TextSelection.create(_tr.doc, from, to));
            }
            return _tr.setSelection(prosemirror_state_1.TextSelection.create(_tr.doc, anchor, head));
        };
        // 根据formatRange来重新设置选区
        tr = tr.setSelection(prosemirror_state_1.TextSelection.create(doc, formatRange.from, formatRange.to));
    }
    // 设置mark类型
    if (schema.marks[formatType]) {
        if (typeof formatValue === 'boolean') {
            toggleMark(schema.marks[formatType], formatValue, tr, state.storedMarks);
        }
        else {
            replaceMark(schema.marks[formatType], formatValue, tr);
        }
    }
    else if (schema.nodes[formatType]) {
        var nodeType_1 = schema.nodes[formatType];
        var selectedInfos = getSelectedInfos(tr);
        if (!selectedInfos.length)
            return tr;
        var resultFrom_1 = doc.nodeSize;
        var resultTo_1 = 0;
        selectedInfos.forEach(function (_a) {
            var selectedNodes = _a.selectedNodes, wrappingRange = _a.wrappingRange, selectedRange = _a.selectedRange;
            var _b = formatNodeType(formatValue ? nodeType_1 : schema.nodes.paragraph, typeof formatValue === 'boolean' ? undefined : formatValue, selectedNodes, selectedRange, wrappingRange, tr, state), rFrom = _b.from, rTo = _b.to;
            resultFrom_1 = Math.min(resultFrom_1, rFrom);
            resultTo_1 = Math.max(resultTo_1, rTo);
        });
        // 若有多个range，一开始计算出来的节点的位置需要考虑前面的节点大小变化
        if (selectedInfos.length > 1) {
            var diffSize = tr.doc.nodeSize - state.doc.nodeSize;
            resultTo_1 += diffSize - Math.floor(diffSize / selectedInfos.length);
        }
        // 选区有拆分,或者是设置的区间实际上包含了当前区间,需要修正选区,保证还是原来的选中内容
        var firstRange = selectedInfos[0];
        var lastRange = selectedInfos[selectedInfos.length - 1];
        if (formatRange || (firstRange.wrappingRange.from < to && lastRange.wrappingRange.to > from)) {
            reSelect = function (_tr) {
                if (state.selection instanceof prosemirror_state_1.AllSelection)
                    return _tr.setSelection(new prosemirror_state_1.AllSelection(_tr.doc));
                ranges.sort(function (a, b) { return a.$from.pos - b.$from.pos; });
                var newRange = getRangeAfterReplace(state, _tr, {
                    extendedFrom: Math.min(from, resultFrom_1),
                    extendedTo: Math.max(to, resultTo_1),
                    $originFrom: ranges[0].$from,
                    $originTo: ranges[ranges.length - 1].$to
                });
                return _tr.setSelection(prosemirror_state_1.TextSelection.create(_tr.doc, newRange.from, newRange.to));
            };
        }
        tr.setSelection(prosemirror_state_1.TextSelection.create(tr.doc, resultFrom_1, resultTo_1));
    }
    return reSelect(tr);
}; };
exports.formatSelection = formatSelection;
//# sourceMappingURL=format.js.map